module.exports = __webpack_public_path__ + "static/media/md-finger-print.2d6d6576.svg";